import type {
    GettingStarted,
    GettingStartedAudience,
    GettingStartedStep
} from '../api/gettingStarted/useGettingStarted';

/**
 * Whether to nudge someone towards Getting started (the dashboard card and the
 * navbar pill): until every required step is done, unless they hid it.
 */
export const shouldPromptGettingStarted = (
    status: Pick<GettingStarted, 'dismissed' | 'complete'> | undefined
): boolean => !!status && !status.dismissed && !status.complete;

/** The next thing to do: the first required step not done, else the first optional one. */
export const nextGettingStartedStep = (
    steps: GettingStartedStep[]
): GettingStartedStep | undefined =>
    steps.find(step => !step.done && !step.optional) ??
    steps.find(step => !step.done);

/** "3 of 6", for the progress line. */
export const gettingStartedProgress = (
    status: Pick<GettingStarted, 'requiredDone' | 'requiredTotal'>
): string => `${status.requiredDone} of ${status.requiredTotal}`;

const OPENING_PROMPTS: Record<GettingStartedAudience, string> = {
    administrator:
        'Help me get our Certavue workspace set up. Check what is already done and tell me the best next step.',
    maintainer:
        'Help me get our people and projects into Certavue. Check what is already done and tell me the best next step.',
    member: 'I am new to Certavue. Show me where to find my work and what I should set up for myself.'
};

/** What "Help me get started" sends to the assistant, by who is asking. */
export const openingPrompt = (audience: GettingStartedAudience): string =>
    OPENING_PROMPTS[audience];
